export enum Permission {
    ReadUser = 0,
    WriteUser = 1,
    ReadAgreement = 2,
    WriteAgreement = 3,
    ReadCustomer = 4,
    WriteCustomer = 5,
    ReadCounterpart = 6,
    WriteCounterpart = 7,
    ReadInbox = 8,
    WriteTenant = 9
}
